import {MapSettingEnum} from '../../../shared/GameEnums'
import {StorageWrapper} from './StorageWrapper'
import {UIDeviceController} from './ui_html/UIDeviceController'

// Also add to ServerEjsVariables & UIUtilsEjsVariables.ts & ejs_variables.ejs
declare global {
    interface Window {
        isProduction: boolean
        freeMap: number
        discordChannelUrl: string
        socketDebugActive: boolean
        socketServerWSS: string
        logRocketId: string
        vliPreRoll: string
        language: string
        isUserOnDiscord: boolean
        isUserOnDiscordMobile: boolean
        discordSDKClientId: string
        isUserOnMobileAppOrWeb: boolean
        isUserOnMobile: boolean
        discordSKUIds: Record<string, string>
        versionNumber: number
        analyticsActive: boolean
        canPurchaseCoinsOnDiscord: boolean
        showConsoleLogUI: boolean
        showVliAdAtBottomInGame: boolean
        frontendSentryDSN: string
        mobileAppSentryDSN: string
        frontendSentryEnvironment: string
        frontendSentryTraceSampleRate: number
        vliPublicKey: string
        vliAdvKey: string
        supportEmail: string
        shouldHideStoreOnMobile: boolean
        shouldHideAdsOnMobile: boolean
        hotjarTrackingCode: string
        shouldEnableNativePaymentsOnMobile: boolean
        isPushNotificationsEnabled: boolean
        activeLandscapePortraitABTest: boolean
        colonistRushEnabled: boolean
        showUpdateAppPopupForVersion: number
        hideLandscapeForNewPlayers: boolean
        assetPath: string // used by webpack
        shouldDisableStoreOnAndroidMobile: boolean
    }
}

// TODO DO NOT add new user or request specific variables, use the client user state: https://github.com/colonistio/katan/issues/17254
export class UIUtilsEjsVariables {
    // Configuration camelCase
    static readonly language = window.language
    static readonly isProduction = window.isProduction
    static readonly freeMap: MapSettingEnum = window.freeMap
    static readonly socketDebugActive = window.socketDebugActive
    static readonly ejsSocketServerWss = window.socketServerWSS
    static readonly logRocketId = window.logRocketId
    static readonly vliPrerollId = window.vliPreRoll
    static readonly isUserOnDiscord = window.isUserOnDiscord
    static readonly discordSDKClientId = window.discordSDKClientId
    static readonly isUserOnMobileAppOrWeb = UIDeviceController.isUserOnMobileAppOrWeb()
    static readonly isUserOnMobile = window.isUserOnMobile
    static readonly isUserOnTabletApp = UIDeviceController.isUserOnTabletApp()
    static readonly isUserOnDiscordMobile = window.isUserOnDiscordMobile || UIDeviceController.isUserOnDiscordMobile()
    static readonly shouldDisplayNewMobileGameUI = StorageWrapper.isPortraitGamePlayEnabled()
    static readonly discordSKUIds = window.discordSKUIds
    static readonly versionNumber = window.versionNumber
    static readonly analyticsActive = window.analyticsActive
    static readonly canPurchaseCoinsOnDiscord = window.canPurchaseCoinsOnDiscord
    static readonly showConsoleLogUI = window.showConsoleLogUI
    static readonly showVliAdAtBottomInGame = window.showVliAdAtBottomInGame
    static readonly frontendSentryDSN = window.frontendSentryDSN
    static readonly mobileAppSentryDSN = window.mobileAppSentryDSN
    static readonly frontendSentryEnvironment = window.frontendSentryEnvironment
    static readonly frontendSentryTraceSampleRate = window.frontendSentryTraceSampleRate
    static readonly vliPublicKey = window.vliPublicKey
    static readonly vliAdvKey = window.vliAdvKey
    static readonly supportEmail = window.supportEmail
    static readonly shouldHideStoreOnMobile = window.shouldHideStoreOnMobile
    static readonly shouldHideAdsOnMobile = window.shouldHideAdsOnMobile
    static readonly hotjarTrackingCode = window.hotjarTrackingCode
    static readonly shouldEnableNativePaymentsOnMobile = window.shouldEnableNativePaymentsOnMobile
    static readonly isPushNotificationsEnabled = window.isPushNotificationsEnabled
    static readonly activeLandscapePortraitABTest = window.activeLandscapePortraitABTest
    static readonly colonistRushEnabled = window.colonistRushEnabled
    static readonly showUpdateAppPopupForVersion = window.showUpdateAppPopupForVersion
    static readonly hideLandscapeForNewPlayers = window.hideLandscapeForNewPlayers
    static readonly shouldDisableStoreOnAndroidMobile = window.shouldDisableStoreOnAndroidMobile
}
